import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HistorialSolicitudes } from '../../../core/model/inventories';
import { Page } from '../../../core/model/page';
import { InventariosService } from '../../../core/services/inventarios.service';

@Component({
  selector: 'app-historial-solicitudes',
  templateUrl: './historial-solicitudes.component.html',
  styleUrls: ['./historial-solicitudes.component.css']
})
export class HistorialSolicitudesComponent implements OnInit {

  @ViewChild('tableRequestHistory') table: any;

  @Input() expedienteId: number;
  @Input() historialSolicitudes: HistorialSolicitudes[];

  @Input() set isRequestHistoryTab(isRequestHistory: boolean) {
    if (isRequestHistory && !this.historialSolicitudes) {
      this.isLoadingData = true;
      this.inventarioService.getHistorialSolicitudes(this.expedienteId)
        .subscribe((data: HistorialSolicitudes[]) => {
          this.historialSolicitudes = data;
          this.historialSolicitudesChange.emit(data);
          this.page.totalElements = data.length;
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          this.isLoadingData = false;
        });
    }
  }

  @Output() historialSolicitudesChange = new EventEmitter<HistorialSolicitudes[]>();

  isLoadingData: boolean;

  page = new Page();

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  constructor(private inventarioService: InventariosService,
    private router: Router) { }

  ngOnInit() {
    this.page.pageNumber = 1;
    this.page.size = 10;
  }

  onResizedTable(event: any): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  viewDetail(identificador: string) {
    this.router.navigate(['docout', { outlets: { contenido: ['detalle', identificador] } }]);
  }

}
